import { Box, Card, Grid } from "@mui/material";
import QRCode from "../../../qrCode/qrCode";
import { useState } from "react";
import FotoEdit from "../../../utils/fotoEdit";
import './fichaAdmin.css';
import StatusEstabelecimento from "../../../utils/status/statusEstabelecimento";
import InfoFieldGroup from "../../../utils/InfoField/InfoFieldGroup";

export default function FichaImportadorSingular({ importador, local, list }) {
  // const user = useSelector((state) => state.account.user);
  // const { id } = useParams()
  const [openEditFoto, setOpenEditFoto] = useState(false);
  const baseUrl = window.location.origin;

  return (
    <>
      <Card>

        <Box className="profile-container">
          <div className="profile-card">
            <div className={`${list === true ? "profile-card-content-1" : "profile-card-content"}`}>
              {/* Image Section */}
              <Grid container  >
                <Grid item xs={12} sm>

                  <div className="profile-image-section">

                    <img
                      src={importador?.logo}
                      alt="Profile"
                      className="profile-image"
                    />

                    <FotoEdit
                      openEditFoto={openEditFoto}
                      setOpenEditFoto={setOpenEditFoto}
                      dadosPessoais={importador}
                      viewEdit={true}
                    />

                    <div className="profile-function-badge">
                      <StatusEstabelecimento status={importador?.status} />
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={8}>
                  <div className="profile-info-section">
                    <div className="profile-qr-container">
                      <div className="profile-qr-box">
                        <QRCode
                          link={`${baseUrl}/verifica-estabecimento/${importador?._id}`}
                          style={{ width: 40, height: 40, color: '#374151' }}
                        />
                      </div>
                    </div>

                    <div className="profile-info-content">
                      <div className="profile-name-section">
                        <h1 className="profile-name-title">
                          {importador?.nome || "N/A"}
                        </h1>
                        <div className="profile-name-underline"></div>
                      </div>
                      <InfoFieldGroup
                        // submit={submitEdit}
                        // data={editDados}
                        // handleChange={handleChange}
                        // setIsEdit={setIsEdit}
                        isEdit={false}
                        load={false}
                        fields={
                          [
                            // { label: 'Estado', value: <StatusSolicitacoes status={?.status} />, editable: false, },
                            { label: 'Nome', value: importador?.nome, key: 'nome', onChange: (v) => 'setEditDados({ ...editDados, nome: v.target.value })' },
                            { label: 'Indentificação', value: importador?.numeroAutorizacao, key: 'numeroAutorizacao', onChange: (v) => 'setEditDados({ ...editDados, numeroAutorizacao: v.target.value })' },
                            { label: 'Contacto', value: importador?.tel1, key: 'tel1', onChange: (v) => 'setEditDados({ ...editDados, tel1: v.target.value })' },
                            { label: 'E-mail', value: importador?.email, key: 'email', onChange: (v) => 'setEditDados({ ...editDados, email: v.target.value })' },
                            { label: 'Provincia', value: importador?.provincia, key: 'provinciaId', onChange: (v) => 'setEditDados({ ...editDados, provinciaId: v.target.value })' },
                            { label: 'Município', value: importador?.municipio, key: 'municipio', onChange: (v) => 'setEditDados({ ...editDados, municipio: v.target.value })' },
                            { label: 'Bairro', value: importador?.bairro, key: 'bairro', onChange: (v) => 'setEditDados({ ...editDados, bairro: v.target.value })' },
                            { label: 'Rua', value: importador?.rua, key: 'rua', onChange: (v) => 'setEditDados({ ...editDados, rua: v.target.value })' },
                          ]
                        } />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </Box>
      </Card>

      <embed
        id="pdfIframe"
        title={`PDF Viewer`}
        src={[importador?.docs?.copiaDI]}
        // maxWidth="50%"
        height="400px"
        style={{ border: 'none', marginTop: 10 }}
      />
    </>
  );
}
